import PropTypes from 'prop-types';
import i18n from 'src/utils/translate';

import Button from 'src/components/buttons/button';
import FollowSuccessMessage from 'src/modules/community/shared/components/alert/followSuccessMessage';

import { showSignupModal, showModal } from 'src/modules/shared/modal/actions';
import { followCommunity } from 'src/modules/community/shared/actions';
import { connect } from 'react-redux';
import signupContext from 'src/constants/signupContext';
import { trackFootfallEvent } from 'src/utils/footfall';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import modalTypes from 'src/constants/modalTypes';
import { showGuidelines } from 'src/modules/community/shared/components/communityGuidelinesModal';

export const onWriteClick = async ({
  community,
  currentUser,
  followCommunity,
  showSignupModal,
  showModal,
  trackingSection,
}) => {

  if (!currentUser) {
    showSignupModal(
      {
        element: signupContext.element.WRITE,
        section: signupContext.section.COMMUNITY,
      },
      community,
    );
    trackFootfallEvent(footfallEventTypes.CLICKED, {
      clickType: 'sign-up',
      clickMetadata: { section: trackingSection, element: 'write-post' },
    });
  } else if (!currentUser.followedCommunities.find(x => x.slug === community.slug)) {
    await showModal({
      modalProps: {
        accept: i18n.t('Join'),
        cancel: i18n.t('Cancel'),
        title: i18n.t('Write a post'),
        onAccept: async () => {
          await followCommunity(community, currentUser.userId, <FollowSuccessMessage communityName={community.name}/>);
          if (showGuidelines(community)) {
            await showModal({
              modalType: modalTypes.COMMUNITY_GUIDELINES,
              modalProps: {redirect: true},
            });
          } else {
            setTimeout(() => {
              window.location.href = `/${community.slug}/write`;
            }, 500);
          }
        },
        children: i18n.t('You need to join this community to be able to write a post or ask a question'),
      },
    });
  } else if (showGuidelines(community)) {
    showModal({
      modalType: modalTypes.COMMUNITY_GUIDELINES,
      modalProps: {redirect: true},
    });
  } else {
    window.location.href = `/${community.slug}/write`;
  }
};

const WriteButton = ({
  className,
  community,
  currentUser,
  followCommunity,
  children,
  showSignupModal,
  showModal,
  trackingSection,
}) => (
  <Button
    className={className}
    dataTestId="write-button"
    icon="pencil-1"
    onClick={() => onWriteClick({
      community,
      currentUser,
      followCommunity,
      showSignupModal,
      showModal,
      trackingSection,
    })}
  >
    {children}
  </Button>
);

WriteButton.propTypes = {
  community: PropTypes.object.isRequired,
  trackingSection: PropTypes.string.isRequired,
  className: PropTypes.string,
  currentUser: PropTypes.object,
  followCommunity: PropTypes.func,
  showModal: PropTypes.func,
  showSignupModal: PropTypes.func,
};

WriteButton.defaultProps = {
  currentUser: null,
  className: '',
  showSignupModal: () => {},
  showModal: () => {},
  followCommunity: () => {},
};

export default connect(null, { showSignupModal, showModal, followCommunity })(WriteButton);
